export const nperItems = Array.apply(null, { length: 10 }).map(Number.call, Number).map(i => {
  const nper = (i * 12) + 12
  return {
    text: nper + ' Maanden',
    value: nper
  }
})

export const workSituationItems = [
  {
    text: 'Geen dienstverband',
    value: 'no_work'
  },
  {
    text: 'Vast (fulltime)',
    value: 'steady_fulltime'
  },
  {
    text: 'Vast (parttime)',
    value: 'steady_parttime'
  },
  {
    text: 'Tijdelijk (fulltime)',
    value: 'temp_fulltime'
  },
  {
    text: 'Tijdelijk (parttime)',
    value: 'temp_parttime'
  },
  {
    text: 'Zelfstandig',
    value: 'independent'
  },
  {
    text: 'Uitzendbureau',
    value: 'employmentagency'
  },
  {
    text: 'Gepensioneerd',
    value: 'retired'
  },
  {
    text: 'Arbeidsongeschikt',
    value: 'incapacitated'
  },
  {
    text: 'Werkloos',
    value: 'unemployed'
  }
]

export const productTypeItems = [ // This list also exists in backend
  {
    text: 'Extra financiële ruimte',
    value: 'misc'
  },
  {
    text: 'Auto / Bedrijfswagen',
    value: 'car'
  },
  {
    text: 'Motor',
    value: 'motorcycle'
  },
  {
    text: 'Fiets',
    value: 'bicycle'
  },
  {
    text: 'Keuken',
    value: 'kitchen'
  },
  {
    text: 'Caravan',
    value: 'caravan'
  },
  {
    text: 'Boot',
    value: 'boat'
  },
  {
    text: 'Vloeren',
    value: 'floors'
  },
  {
    text: 'Kozijnen',
    value: 'window frames'
  },
  {
    text: 'Overkapping / Veranda',
    value: 'porch'
  },
  {
    text: 'Electronica',
    value: 'electronics'
  }
]

export const leaseOptionsAll = [
  {
    defaultEnabled: true,
    name: 'car_insurance',
    label: 'Autoverzekering',
    productType: ['car'],
    price: 0
  }
]
